import Vue from 'vue'
import App from './App.vue'
if (!global._babelPolyfill) {
  require('babel-polyfill')
}

window.ICC =  {
  init: (config) => {
    const icc = document.createElement('div');
    icc.setAttribute('id', 'icc');
    document.body.appendChild(icc);
    return new Vue({
      el: '#icc',
      data: {config},
      render: h => h(App)
    });
  },
}

if(window.ICC_CALLBACK){
  window.ICC_CALLBACK(window.ICC);
}



// WEBPACK FOOTER //
// ./src/main.js